import React from 'react'
import { Box, makeStyles } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import DT from './images/depart-transcend.png'
import isMobile from './utils/is-mobile'

const useStyles = isMobile()
  ? makeStyles({
      carouselContainer: {
        margin: 30,
        width: '50%',
        height: 600,
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
      },
      imageContainer: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
      },
      container: {
        display: 'flex',
        flex: 1
      },
      description: {
        marginTop: 10,
        width: '90%',
        alignSelf: 'center',
        display: 'inline-block',
        whiteSpace: 'pre-line'
      },
      textContainer: {
        textAlign: 'center'
      }
    })
  : makeStyles({
      carouselContainer: {
        margin: 30,
        width: '50%',
        height: 600,
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
      },
      imageContainer: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
      },
      container: {
        display: 'flex',
        flex: 1
      },
      description: {
        marginTop: 20,
        width: '60%',
        alignSelf: 'center',
        display: 'inline-block',
        whiteSpace: 'pre-line'
      },
      textContainer: {
        textAlign: 'center'
      }
    })

const Armando: React.FC = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  return (
    <>
      <Box className={classes.container}>
        <Box className={classes.carouselContainer}>
          <a
            href='https://www.depart-transcend.com'
            rel='noreferrer'
            target='_blank'
          >
            <img src={DT} alt='a' height={600} />
          </a>
        </Box>
      </Box>
      <Box className={classes.textContainer}>
        <Box className={classes.description}>{t('armandoDescription')}</Box>
      </Box>
    </>
  )
}

export default Armando
